import styled from "@emotion/styled";
import {
  Button,
  type ButtonAttributes,
  type ButtonProps,
  type breakpoint,
  useBreakpoint,
} from "@repo/skapa";

interface Props {
  breakpoint: breakpoint;
  text?: string;
  icon?: (...args: any[]) => any;
  showIcon?: boolean;
}

const isMatch = (bp: breakpoint, actualBp: breakpoint) => {
  switch (bp) {
    case "sm": {
      return ["sm", "md", "lg", "xl"].includes(actualBp);
    }
    case "md": {
      return ["md", "lg", "xl"].includes(actualBp);
    }
    case "lg": {
      return ["lg", "xl"].includes(actualBp);
    }
    case "xl": {
      return ["xl"].includes(actualBp);
    }
    default: {
      return false;
    }
  }
};

const NoWrapContainer = styled.span`
  white-space: nowrap;
`;

export const ResponsiveButton = ({
  breakpoint: bp,
  text,
  icon,
  showIcon,
  iconPosition,
  title,
  ...rest
}: Props & ButtonProps & ButtonAttributes) => {
  const actualBreakpoint = useBreakpoint("sm", "md", "lg", "xl");
  const match = isMatch(bp, actualBreakpoint ?? "sm");

  if (match || actualBreakpoint === undefined) {
    return (
      <Button
        text={<NoWrapContainer>{text}</NoWrapContainer>}
        ssrIcon={showIcon ? icon : undefined}
        iconPosition={iconPosition}
        title={title}
        {...rest}
      />
    );
  }

  return <Button iconOnly ssrIcon={icon} text={text} title={title} {...rest} />;
};
